import { createFileRoute } from "@tanstack/react-router";
import { useProject } from "@/api/projects";
import { Page } from "@/components/shell/PageHeader";
import { SourcesPanel } from "@/components/sources/SourcesPanel";

export const Route = createFileRoute("/_app/projects/$projectId/sources")({ component: SourcesPage });

function SourcesPage() {
  const { projectId } = Route.useParams();
  const project = useProject(projectId);
  if (!project.data) return null;
  return (
    <Page>
      <SourcesPanel projectId={project.data.id} />
    </Page>
  );
}
